// toast.js
import './toast.css';

export function showToast(message, type = 'success') {
  const toast = document.createElement('div');
  toast.className = `custom-toast ${type}`;
  toast.textContent = message;
  document.body.appendChild(toast);

  setTimeout(() => {
    toast.remove();
  }, 3000); // matches animation duration
}
